const updateAllowedProps = [
  'department',
  'name',
  'position',
]

class Institution {
  constructor(options = {}) {
    options = options || {}
    this.department = options.department
    this.name = options.name
    this.position = options.position
  }

  // Class methods
  static init(options) {
    if (options instanceof Institution) {
      return options
    }
    const instance = new Institution(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this
  }
  setModified() {
    this.modified = (new Date()).valueOf()
    return this
  }
  updateInstitution(update) {
    Object.keys(update).forEach((key) => {
      if (updateAllowedProps.includes(key)) {
        this[key] = update[key]
      }
    })
    return this.setModified()
  }
}

export default {
  Institution
}
export {
  Institution
}
